import { ManfrediteLinkedinProfileImportJobApiRequest } from './manfredite-linkedin-profile-import-job-api.request';
export const createMockedManfrediteLinkedinProfileImportApiRequest = (customValues = {}) => {
    const request = new ManfrediteLinkedinProfileImportJobApiRequest();
    request.token = customValues.token ?? 'token';
    return request;
};
//# sourceMappingURL=manfredite-linkedin-profile-import-job-api.request.mock.js.map